<script lang="ts">
  import { Text } from "@getprovi/craft-svelte";
  import { pluralize } from "@shared/svelte/Modules/pluralize";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import OrderRequestedProduct from "@retailer/svelte/OrderDetail/OrderRequestedProduct.svelte";

  // types
  import type { SharedOrder } from "@shared/types/Order";
  import type { CartProduct } from "@shared/types/ProductLine";

  export let requestedItems: CartProduct[];
  export let order: SharedOrder;
  export let Product;
</script>

<div class="craft fizz-inset-square-16">
  <div class="bg-neutral-light fizz-inset-square-16">
    <div class="flex justify-between">
      <div>
        <Text as="span" size="sm" semibold>Requested Items</Text>
        <Text as="span" size="sm" color="neutral"
          >({pluralize("Item", requestedItems.length, true)})</Text
        >
      </div>
      <Text size="sm" semibold>+<FormatMoney input={order.requested_items_total} /></Text>
    </div>
    <Text size="xs" color="neutral"
      >Unless these items are fulfilled, they won’t count towards a distributor’s order minimum or
      your order total.</Text
    >
  </div>
  {#each requestedItems as item}
    <div>
      <OrderRequestedProduct product={item} {Product} distributor={order.distributor} />
    </div>
  {/each}
</div>
